import React, { useCallback, useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { organizationActions } from "../../../redux/actions/guides";
import { guideService } from "../../../services/api.guides";
import { notify } from "reapop";
import { SimpleModal, MyInput, SimpleTabs, TabPanel, DialogModal, MyCheckBox } from "../../../components";
import { Grid, Divider, Tab, Button } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import * as Yup from "yup";
import { Payments } from "../components/Payments";
import { Uploadfile } from "../../../components/uploads/UploadFile";

const defaultValues = {
  nameOrganization: "",
  code: "",
  phone: "",
  email: "",
  address: "",
  director: "",
  accountAnt: "",
  description: "",
  fullName: "",
  inn: "",
  kpp: "",
  ogrn: "",
  okpo: "",
  // Поля почтовых настроек
  mailHost: "",
  mailPort: 993,
  mailUserName: "",
  mailPassword: "",
  mailIsEnabled: true,
  mailIntervalMinutes: 2,
  mailFetchStartDate: null,
};

const labelObjects = {
  logo: 'Лого',
  stamp: 'Печать',
  directorSignature: 'Подпись руководителя',
  accountantSignature: 'Подпись главного бухгалтера'
};

const initialPhotos = {
  logo: null,
  stamp: null,
  directorSignature: null,
  accountantSignature: null
};

const validationSchema = Yup.object().shape({
  nameOrganization: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Укажите наименование"),
  code: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  fullName: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  email: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  description: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  address: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  director: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  accountAnt: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  inn: Yup.string().required("Укажите ИНН").max(12, "Превышено максимальное кол-во символов(12)").nullable(),
  kpp: Yup.string().max(9, "Превышено максимальное кол-во символов(9)").nullable(),
  okpo: Yup.string().max(25, "Превышено максимальное кол-во символов(15)").nullable(),
  
  // Валидация почты (проверяем только если заполнено имя хоста)
  mailHost: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  mailPort: Yup.number().typeError("Укажите число").nullable(),
  mailUserName: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  mailPassword: Yup.string().nullable(),
  mailIntervalMinutes: Yup.number().typeError("Укажите число").min(1, "Минимум 1 мин").nullable(),
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const ModalOrganization = ({ modalShow, onClose, isAddMode, setIsAddMode, id, refresh = () => { } }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.organizations);
  const [selected, setSelected] = useStateIfMounted(0);
  const [files, setFile] = useStateIfMounted(initialPhotos);
  const [originalFiles, setOriginalFiles] = useStateIfMounted(initialPhotos);
  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);

  const onChangeFile = async (label, file) => {
    const orgId = item?.id ?? id;
    if (isAddMode || !orgId) {
      setFile(prevFiles => ({
        ...prevFiles,
        [label]: file
      }));
      return;
    }

    try {
      const photoType = label.charAt(0).toUpperCase() + label.slice(1);
      const result = await guideService.uploadOrganizationPhoto(orgId, photoType, file);
      setFile(prevFiles => ({
        ...prevFiles,
        [label]: result || null
      }));
      setOriginalFiles(prevFiles => ({
        ...prevFiles,
        [label]: result || null
      }));
    } catch (e) {
      dispatch(notify({
        title: "Ошибка при загрузке файла",
        message: e.message,
        status: "error",
        image: "/public/assets/images/illustrations/close.svg"
      }));
    }
  };

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = methods;

  const handleChange = (event, newValue) => {
    setSelected(newValue);
  };

  const onSubmit = (data) => {
    const formData = new FormData();

    for (const key in data) {
      if (data.hasOwnProperty(key) && key !== "Stampss" && key !== "payments") {
        const value = data[key] === "null" || data[key] === null ? "" : data[key];
        formData.append(key, value);
      }
    }

    Object.keys(files).forEach(key => {
      if (files[key] !== originalFiles[key]) {
        formData.append(`Stamps.${key.charAt(0).toUpperCase() + key.slice(1)}`,
          files[key] || null);
        formData.append(`Stamps.IsChange${key.charAt(0).toUpperCase() + key.slice(1)}`,
          files[key] !== originalFiles[key]);
      }
    });

    if (Array.isArray(data.payments)) {
      data.payments.forEach((payment, index) => {
        Object.entries(payment).forEach(([field, value]) => {
          formData.append(`payments[${index}].${field}`, value ?? "");
        });
      });
    }

    return isAddMode
      ? dispatch(organizationActions.create(formData))
      : dispatch(organizationActions.update(item.id, formData));
  };

  const handleDeleteClick = useCallback((id) => {
    dispatch(organizationActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  useEffect(() => {
    setSelected(0);
    if (!modalShow || isAddMode) return;
    dispatch(organizationActions.getById(id));
    return () => dispatch({ type: "RESET_ITEM_ORGANIZATIONS" });
  }, [modalShow]);

  useEffect(() => {
    if (!fetchedItem || isAddMode || !item) return;

    if (item?.photos) {
      const photos = {
        ...initialPhotos,
        ...item.photos
      };
      setFile(photos);
      setOriginalFiles(photos);
    }

    // Заполнение стандартных полей
    Object.keys(defaultValues).forEach((field) => {
      if (item[field] !== undefined) {
        setValue(field, item[field]);
      }
    });

    // Заполнение настроек почты, если они приходят внутри объекта организации
    if (item.mailSetting) {
      setValue("mailHost", item.mailSetting.host);
      setValue("mailPort", item.mailSetting.port);
      setValue("mailUserName", item.mailSetting.userName);
      setValue("mailIsEnabled", item.mailSetting.isEnabled);
      setValue("mailIntervalMinutes", item.mailSetting.intervalMinutes);
      setValue("mailFetchStartDate", item.mailSetting.fetchStartDate ? item.mailSetting.fetchStartDate.split('T')[0] : null);
      // Пароль оставляем пустым, меняем только при необходимости
      setValue("mailPassword", "");
    }
  }, [item, fetchedItem]);

  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
    }
  }, [deleted]);

  useEffect(() => {
    if (!error && isAddMode && fetchedItem) {
      setIsAddMode(false);
    }
  }, [error, loadingItem, fetchedItem]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
    setFile(initialPhotos);
    setOriginalFiles(initialPhotos);
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новая организация" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="md"
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
        additionalActions={
          <Button
            disabled={item?.id === null || item?.id === undefined}
            aria-describedby={id}
            size="small"
            color="primary"
            onClick={() => setDeleteDialog(true)}
            startIcon={<DeleteIcon />}
          >
            Удалить
          </Button>
        }
      >
        <FormProvider {...methods}>
          <form noValidate>
            <SimpleTabs
              handleChange={handleChange}
              value={selected}
              panels={
                <div style={{ minHeight: "360px" }}>
                  {/* Вкладка 1: Основная информация */}
                  <TabPanel value={selected} index={0}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={8}>
                        <MyInput name="nameOrganization" control={control} label="Наименование организации" required errors={errors?.nameOrganization} />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <MyInput name="inn" control={control} label="ИНН" required errors={errors?.inn} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="phone" control={control} label="Телефон" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="email" control={control} label="Email" errors={errors?.email} />
                      </Grid>
                      <Grid item xs={12}>
                        <MyInput name="address" control={control} label="Фактический адрес" multiline rows={2} errors={errors?.address} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="director" control={control} label="ФИО директора" errors={errors?.director} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="accountAnt" control={control} label="ФИО главного бухгалтера" errors={errors?.accountAnt} />
                      </Grid>
                      <Grid item xs={12}>
                        <MyInput name="description" control={control} label="Примечание" multiline rows={2} errors={errors?.description} />
                      </Grid>
                      <Grid container spacing={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                        {Object.entries(labelObjects).map(([key, value]) => (
                          <Grid item xs={12} sm={6} md={3} key={key} style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <Uploadfile
                              labelKey={key}
                              label={value}
                              file={files[key]}
                              onChange={onChangeFile}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </TabPanel>

                  {/* Вкладка 2: Реквизиты */}
                  <TabPanel value={selected} index={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <MyInput name="fullName" control={control} label="Полное наименование" errors={errors?.fullName} />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <MyInput name="code" control={control} label="Код" errors={errors?.code} />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <MyInput name="kpp" control={control} label="КПП" errors={errors?.kpp} />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <MyInput name="ogrn" control={control} label="ОГРН" errors={errors?.ogrn} />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <MyInput name="okpo" control={control} label="ОКПО" errors={errors?.okpo} />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider variant="middle" style={{ marginTop: 10, marginBottom: 10 }} />
                      </Grid>
                      <Grid item xs={12}>
                        <Payments isAddMode={isAddMode} />
                      </Grid>
                    </Grid>
                  </TabPanel>

                  {/* Вкладка 3: Интеграция с почтой */}
                  <TabPanel value={selected} index={2}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={8}>
                        <MyInput name="mailHost" control={control} label="IMAP Сервер" errors={errors?.mailHost} />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <MyInput name="mailPort" type="number" control={control} label="Порт" errors={errors?.mailPort} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="mailUserName" control={control} label="Логин / Email" errors={errors?.mailUserName} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="mailPassword" type="password" control={control} label="Пароль (оставьте пустым, если не меняется)" errors={errors?.mailPassword} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="mailIntervalMinutes" type="number" control={control} label="Интервал проверки (в минутах)" errors={errors?.mailIntervalMinutes} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MyInput name="mailFetchStartDate" type="date" InputLabelProps={{ shrink: true }} control={control} label="Дата начала загрузки писем" errors={errors?.mailFetchStartDate} />
                      </Grid>
                      <Grid item xs={12}>
                        <MyCheckBox name="mailIsEnabled" control={control} label="Обрабатывать письма с почты" />
                      </Grid>
                    </Grid>
                  </TabPanel>
                </div>
              }
            >
              <Tab label="Основная информация" {...a11yProps(0)} />
              <Tab label="Реквизиты" {...a11yProps(1)} />
              <Tab label="Почта" {...a11yProps(2)} />
            </SimpleTabs>
          </form>
        </FormProvider>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить организацию - ${item?.nameOrganization}? Это действие невозможно отменить.`}
      />
    </div>
  );
};